import * as React from "react";
import { render } from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";

import { Provider } from "react-redux";
import { AppProvider } from "./context";
import { RhinoProvider } from "./pages/RFC/states";

import App from "./App";
import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";

import "./i18n";
import { TranslationProvider } from "./context/TranslationContext";

/*const store: Store<ArticleState, ArticleAction> & {
  dispatch: DispatchType
} = createStore(reducer, composeEnhancers(applyMiddleware(thunk)))
*/

render(
  <Provider store={store}>
    <React.Suspense fallback={<div>Loading...</div>}>
      <AppProvider>
        <RhinoProvider>
          <PersistGate loading={null} persistor={persistor}>
          <TranslationProvider>
            <App />
          </TranslationProvider>
          </PersistGate>
        </RhinoProvider>
      </AppProvider>
    </React.Suspense>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
